export const reportTypeSchema = {
  properties: {
    type: {
      title: 'Typ raportu',
      type: 'string'
    }
  },
  title: 'Typ raportu'
};
